import React from 'react'
import { StyledLine } from './StyledLine'

const Line = () => {
  return (
    <StyledLine />
  )
}

export default Line